<template>
  <el-row :gutter="30" class="articles-container">
      <el-col v-for="post in posts" :span="8" :key="post.id">
         <el-card :body-style="{ padding: '0px' }">
          <div class="image-box"  v-bind:style="{ backgroundImage: 'url(' + post.attributes.image + ')' }">
            
          </div>
          <div style="padding: 14px;">
            <span class="article-title">{{post.attributes.name}}</span>
            <p class="article-description">{{post.attributes.previewText}}</p>
            <div class="bottom clearfix">
              <el-button type="primary" @click="goToArticle(post.id)" class="button">Read More</el-button>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
</template>

<script>
export default {
  name: 'articles',
  props: ['skip','featured'],
  data () {
    return {
      savingData: false,
      posts:[]
    }
  },
  mounted: function(){
    this.$nextTick(function () {
        this.getPosts();
    });
  },
  methods:{
  	getPosts: function(){
      var _this = this;
      var postQuery = new Parse.Query('Post');
      postQuery.equalTo('status', 'PUBLISHED');
      if(this.featured){
        postQuery.equalTo('featured', true);
      }else{
        postQuery.notEqualTo('featured', true);
      }
      if(this.skip) {
        postQuery.skip(1);
      }
      postQuery.descending('priority');
      postQuery.find()
        .then(function(results){
          _this.posts = results;
        })
        .catch(function(err){
          alert('ERROR GETTING POST');
        });
    },
    goToSignup:function(){
      this.$router.push('/signup/plan');
    },
    goToArticle:function(id){
    	this.$router.push('/dashboard/content/article/'+id);
    }
  }
}
</script>

<style>
.articles-container .el-card {
	margin-bottom: 20px;
}
  .articles-container .image-box {
    width: 100%;
    height: 100px;
    background-size: cover;
  }

  .articles-container .el-card span.article-title{
    font-weight: bold;
    margin: 0;
    text-align: left;
    color: #666;
    width: 100%;
    display: block;
    margin-bottom: 5px;
    white-space: nowrap; 
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .articles-container .el-card p.article-description{
    margin: 0 0 15px;
    font-size: 14px;
    text-align: left;
    color: #666;
    height:90px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .el-card {
  	border-radius: 0;
  	border:0;
  }
</style>
